import { get } from "lodash";

export const getProjectCatalogs = state =>
  get(state, ["pageContent", "project_catalogs"], []);

export default getProjectCatalogs;
